export default __webpack_public_path__ + "static/media/ui.403be4b5.svg";